import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef, Renderer2, Output, EventEmitter
} from '@angular/core';
import { Router } from '@angular/router';
import { ListComponentGeneric } from '../../../../../ui/generics';
import { IBulkContainer } from '../../../core/interfaces/IBulkContainer';
import { NotificationService } from '../../../../../core/services';
import { BulkContainersService, BulkContainersServiceErrorResolverService } from '../../../core/services';

@Component({
    selector: 'app-deliveries-list',
    templateUrl: './deliveries-list.component.html',
    styleUrls: ['./deliveries-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeliveriesListComponent extends ListComponentGeneric<IBulkContainer> {
  @Input() isVariant = false;
  @Input() set articleId(val: number) {
    if(val) {
      this._articleId = val;
      this.predefindedFilters = [{
        value: [val.toString()],
        key: (this.isVariant ? 'articleVariantId':'productionArticleId')
      }];
      this.loadDefault();
    }
  }

  @Output() deliveryCreated = new EventEmitter<void>();
  @Output() deliveryEdited = new EventEmitter<void>();
  @Output() deliveryCancelled = new EventEmitter<void>();
  @Output() changeLogCreated = new EventEmitter<void>();

  protected readonly exportedTableVisibleName = 'Lieferungen-Liste';

  private _articleId: number;

  constructor(
    protected _service: BulkContainersService,
    protected _cdr: ChangeDetectorRef,
    protected _notifyService: NotificationService,
    protected renderer: Renderer2,
    protected _errorResolver: BulkContainersServiceErrorResolverService,
    private _router: Router
  ) {
    super(_service, _cdr, _notifyService, renderer, _errorResolver);
  }

  public openNewProductionOrder(delivery: IBulkContainer): void {
    const productionArticleId = delivery.productionArticleId ?? this._articleId;
    if (!productionArticleId) {
      this._notifyService.pushError('Fehler', 'Produktionsartikel zum Großgebinde fehlt');
      return;
    }
    this._router.navigate(['/production-planning/orders'], {
      queryParams: {
        productionArticleId,
        bagCharge: delivery.charge,
        bulkContainerId: delivery.id
      }
    });
  }

  public get articleId(): number {
    return this._articleId;
  }

  public load(
    pageIndex: number,
    pageSize: number,
    sortField: string | null,
    sortOrder: string | null,
    filter: { key: string; value: string[] }[],
    search: { key: string; value: string[] }[],
    additionalFilters: { key: string; value: string[] }[] = [],
  ): void {
    if (!this._articleId) {
      return;
    }

    super.load(pageIndex, pageSize, sortField, sortOrder, filter, search, additionalFilters);
  }

  cancelBulkContainer(deliveryId: number): void {
    this._service.cancel(deliveryId, true).subscribe({
      next: () => {
        this._notifyService.pushSuccess('Erfolgreich', `Lieferung korrekt storniert`);
        this.onRefreshList(false);
        this.deliveryCancelled.emit();
      },
      error: this.parseError
    });
  }
}
